import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './Checkbox.css';
import QuestionMark from '../widgets/QuestionMark';

const STATE_UN_CHECKED = 0;
const STATE_CHECKED = 2;

export const CheckboxVariants = {
    LIGHT: 'light',
    DARK: 'dark',
};

function Checkbox({
    label = '',
    id = '',
    checked = false,
    disabled = false,
    className = '',
    indeterminate = false,
    threeStatesEnabled = false,
    labelPosition = 'right',
    style = {},
    size = 'medium',
    checkmarkStyle = {},
    labelClass = '',
    errorLabelClass = '',
    error = false,
    onChange = () => {},
    labelTooltip = null,
    variant = 'light',
}) {
    const nextState = () => {
        if (!threeStatesEnabled) {
            return !checked;
        }

        return indeterminate || !checked ? STATE_CHECKED : STATE_UN_CHECKED;
    };

    const innerOnChange = e => {
        if (disabled) {
            return;
        }
        e.stopPropagation();
        onChange(nextState());
    };

    const isDark = variant === CheckboxVariants.DARK;

    return (
        <label
            className={`${css.container}
                        ${disabled ? css.disabled : ''}
                        ${className}
                        ${indeterminate ? css.indeterminate : ''}
                        ${labelPosition === 'left' ? css.reverse : ''}
                        ${css[size]}`}
            htmlFor={`checkbox_${id}`}
            onClick={innerOnChange}
            style={style}
        >
            <input type="checkbox" name={`checkbox_${id}`} checked={checked} onChange={() => {}} disabled={disabled} />
            <span className={classNames(css.checkmark, { [css.error]: error })} style={checkmarkStyle} />
            {label ? (
                <span
                    className={classNames(css.label, labelClass, {
                        [css.errorLabel]: error,
                        [css.dark]: isDark,
                        [errorLabelClass]: errorLabelClass && error,
                    })}
                >
                    {label}
                </span>
            ) : null}
            {labelTooltip ? <QuestionMark message={labelTooltip} /> : null}
        </label>
    );
}

Checkbox.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    id: PropTypes.string,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    indeterminate: PropTypes.bool,
    threeStatesEnabled: PropTypes.bool,
    labelPosition: PropTypes.oneOf(['left', 'right']),
    style: PropTypes.objectOf(PropTypes.any),
    size: PropTypes.oneOf(['small', 'medium']),
    checkmarkStyle: PropTypes.objectOf(PropTypes.any),
    labelClass: PropTypes.string,
    errorLabelClass: PropTypes.string,
    error: PropTypes.bool,
    onChange: PropTypes.func,
    labelTooltip: PropTypes.string,
    variant: PropTypes.oneOf(Object.values(CheckboxVariants)),
};

export default Checkbox;
